<!--
Some notes about this code:

- There are only three ways to close this dialog:
    1 - refresh the page
	2 - the cancel button in steps 1 or 2
	3 - the done button on step 3

- This parent component is where the stepping is done. The subcomponents for the 3 steps don't know
  anything about stepping to a previous or next step.  They only let the parent component know
  if the step is valid or not by emitting messgess.

- The add-devices-dialog.service.ts file is a service that lives and dies with this component and is used
  to share state between steps.

- Attached to the first two steps are a unique formGroup. The underlying step uses the
  validiity of the formgroup for the step to decide if the form is valid, and hence the user should be
  able to procede to the next step.

  For example, in step 1, the user has to select the claiming method. If they select local network,
  the formgroup is updated to indicate valid since not additional data is needed. But, if they select
  either of the other two methods, the form group isn't valid until that additional data is entered
  and validated.

  The user must complete a step before they can proceed to the next.
-->

<prism-stepper-dialog id="add-devices-dialog" [visible]="true" *transloco="let t">
	<prism-stepper #stepper [linear]="true">
		<span slot="stepper-title">{{ t('cloud.add-devices-dialog.add-devices') }}</span>
		<sh-step-router-content-outlet></sh-step-router-content-outlet>
	</prism-stepper>

	<sh-step-router-footer-outlet slot="stepper-footer-buttons"></sh-step-router-footer-outlet>
</prism-stepper-dialog>
